import { createFileRoute } from "@tanstack/react-router";

import { MassAbandonPage } from "@/features/mass-abandon/components/mass-abandon-page";

export const Route = createFileRoute("/_authed/_dashboard/admin-tools/mass-abandon")({
  component: MassAbandonPage,
});
